import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import {
  IWizItemRenderer,
  WizTree,
  WizButton,
  TreeItemWrapper,
  WizDatasource,
  WizEventManager, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent, ScenarioVO, StyleEngine } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';

/**
 * Actions de l'arbre des Freedata values
 */
@Component({
  selector: 'scen-tree-renderer',
  templateUrl: './scen-tree.renderer.html',
})
export class ScenTreeRenderer implements IWizItemRenderer<TreeItemWrapper<ScenarioVO>, ScenarioVO> {
  @HostBinding('style.width') elwidth: string = '100%';

  @ViewChild('addButton', { read: WizButton }) addButton: WizButton;
  @ViewChild('deleteButton', { read: WizButton }) deleteButton: WizButton;


  /**
   * renderer back pour deprecated / deleted
   */
  public deprecated() {
    return false;
  }
  public deleted() {
    return false;
  }

  /**
   * return le libellé traduit s'il existe, sinon une chaine vide
   * @returns le label traduit du freedata value
   */
  public get label(): string {
    let result: string = this.data.code;
    if (!!this.data.trsLabel) {
      result = '(' + result + ') ' + this.data.trsLabel;
    }
    return result;
  }

  /**
   * @returns le type de scenario (entreprise / user)
   */
  public get kindLabel(): string {
    if (!!this.data.userMode) {
      return this.data.owner;
    } else {
      return WizTranslationManager.getInstance().translateKey('$.scen.kind.enterprise.$');
    }
  }


  // donneés rempli par le composant wiz-tree
  data: ScenarioVO;
  owner: WizTree<ScenarioVO>;
  context: TreeItemWrapper<ScenarioVO>;
  
  public get color(): string {
    return this.data?.color || StyleEngine.STYLE_DEFAULT_SCEN_COLOR;
  } 

  constructor(public elementRef: ElementRef) {}

  /** delete autorisé ? */
  public canAdd(): boolean {
    let result: boolean = true;
    return result;
  }

  /** delete autorisé ? */
  public canDelete(): boolean {
    if(this.data.code === ViewData.wildcardMainScenario) {
      return false;
    }
    return true;
  }

  /** demande d'ajout */
  public doAdd(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.ADD, this.data, this));
  }

  /** demande de suppression */
  public doDelete(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.DELETE, this.data, this));
  }

  /**
   * inversion de la couleur des boutons d'action
   * @returns boolean, true si la ligne est sélectionné, false sinon
   */
  public isSelected(): boolean {
    const datas: WizDatasource<any> = this.owner.wizDataProvider;
    if (datas && datas.selectedItems && datas.selectedItems.indexOf(this.data) > -1) {
      return true;
    }
    return false;
  }
}
